import api from "../../commomFun/api.js";
export default {
  data() {
    return {
      currentTagOfTable: {},
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      selectedRowKeys: [],
      tagListColumns: [
        {
          title: "标签ID",
          key: "id",
          dataIndex: "id",
          fixed: "left",
          align: "left",
          width: 80
        },
        {
          title: "标签名称",
          key: "name",
          align: "left",
          width: 150,
          dataIndex: "name",
          ellipsis: true,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "customRender"
          },
          onFilter: (value, record) =>
            record.name
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "应用点位数量",
          key: "pointCount",
          scopedSlots: { customRender: "pointCountSlot" },
          align: "left",
          width: 100,
          ellipsis: true
        },
        {
          title: "更新时间",
          key: "updateTime",
          dataIndex: "updateTime",
          align: "left",
          width: 140
        },
        {
          title: "应用状态",
          key: "status",
          scopedSlots: { customRender: "tagStatus" },
          align: "left",
          width: 120
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          scopedSlots: { customRender: "action" },
          align: "left",
          width: 100
        }
      ],
      pageSizeOptions: ["10", "20", "30", "40"],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    rowSelection() {
      let _this = this;
      const { selectedRowKeys } = _this;
      return {
        selectedRowKeys,
        onChange: _this.onSelectChange,
        onSelectAll(selected) {
          if (selected) {
            _this.selectedRowKeys = _this.currentTagGroup.tagArr.map(
              item => item.id
            );
          } else {
            _this.selectedRowKeys = [];
          }
        }
      };
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 通用表单弹框提交操作
    commonHandleConfirm(formDialogInstance, confirmFun) {
      formDialogInstance.$refs.ruleForm.validate(async valid => {
        if (valid) {
          formDialogInstance.btnLoading = true;
          if (await confirmFun(formDialogInstance.formConfig.form)) {
            formDialogInstance.btnLoading = false;
            formDialogInstance.$refs.ruleForm.resetFields();
            formDialogInstance.$emit("update:visibleModal", false);
            this.currentTagGroup.tagArr = await this.getTagsOfCurrentTagGroup({
              parentId: this.currentTagGroup.id
            });
          } else {
            formDialogInstance.btnLoading = false;
          }
        } else {
          return false;
        }
      });
    },
    // 标签上的多种操作
    handleTagOfGroup(tagOperateType, row) {
      this.currentTagOfTable = row || {};
      switch (tagOperateType) {
        case "addTagGroup":
          this.currentFormConfig = {
            title: "新增标签组",
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            formFieldObj: {
              name: {
                label: "标签组名称：",
                type: "input",
                placeholder: "请输入标签组名称"
              }
            },
            form: {
              name: ""
            },
            formRules: {
              name: [
                {
                  required: true,
                  message: "请输入标签组名称",
                  trigger: "blur"
                },
                { max: 60, message: "最多输入60个字节", trigger: "blur" }
              ]
            },
            handleConfirm: formDialogInstance =>
              this.commonHandleConfirm(formDialogInstance, this.addTagGroup),
            handleCancel: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            },
            handleAfterClose: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            }
          };
          this.visibleFormModal = true;
          break;
        case "addTag":
          this.currentFormConfig = {
            title: "新增标签",
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            formFieldObj: {
              name: {
                label: "标签名称：",
                type: "input",
                placeholder: "请输入标签名称"
              }
            },
            form: {
              name: ""
            },
            formRules: {
              name: [
                {
                  required: true,
                  message: "请输入标签名称",
                  trigger: "blur"
                },
                { max: 60, message: "长度不超过60个字符", trigger: "blur" }
              ]
            },
            handleConfirm: formDialogInstance =>
              this.commonHandleConfirm(formDialogInstance, this.addTag),
            handleCancel: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            },
            handleAfterClose: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            }
          };
          this.visibleFormModal = true;
          break;
        case "updateTagName":
          this.currentFormConfig = {
            title: "编辑标签",
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            formFieldObj: {
              parentId: {
                label: "所属标签组：",
                type: "select",
                options: this.tagGroupArr || [],
                placeholder: "请选择标签组"
              },
              name: {
                label: "标签名称：",
                type: "input",
                placeholder: "请输入标签名称"
              }
            },
            form: {
              parentId: this.currentTagGroup.id || "",
              name: this.currentTagOfTable.name || ""
            },
            formRules: {
              parentId: [
                {
                  required: true,
                  message: "请选择所属标签组",
                  trigger: "blur"
                }
              ],
              name: [
                {
                  required: true,
                  message: "请输入标签名称",
                  trigger: "blur"
                },
                { max: 60, message: "长度不超过60个字符", trigger: "blur" }
              ]
            },
            handleConfirm: formDialogInstance =>
              this.commonHandleConfirm(
                formDialogInstance,
                this.updateTagAttribute
              ),
            handleCancel: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            },
            handleAfterClose: formDialogInstance => {
              formDialogInstance.$emit("update:visibleModal", false);
            }
          };
          this.visibleFormModal = true;
          break;
        case "showPointsToTagModal":
          this.visiblePointsToTagModal = true;
          break;
        default:
          break;
      }
    },

    changePage(page) {
      this.currentPage = page;
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current;
      this.pageSize = pageSize;
    },
    // 新增标签
    addTag(params) {
      return new Promise(resolve => {
        api
          .postApi("/tags", {
            ...params,
            parentId: this.currentTagGroup.id
          })
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success(res.data.msg || "新增标签成功！");
              resolve(true);
            } else {
              this.$message.warning(res.data.msg || "新增标签失败！");
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    // 修改单个标签属性弹框
    updateTagAttribute(params) {
      if (!this.currentTagOfTable.id) {
        this.$message.warning("标签id获取失败！");
        return false;
      }
      return new Promise(resolve => {
        api
          .putApi(`/tags/${this.currentTagOfTable.id}/`, params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success(res.data.msg || "标签操作成功！");
              resolve(true);
            } else {
              this.$message.warning(res.data.msg || "标签操作失败！");
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    // 单个修改标签状态
    onTagStatusChange(row, checked) {
      console.log("checked", checked);
      if (!row.id) {
        this.$message.warning("标签id获取失败！");
        return;
      }
      api.putApi(`/tags/${row.id}/`, { enable: checked }).then(res => {
        if (res.data.code === 200) {
          row.status = checked === true ? 0 : -1;
          this.$forceUpdate();
          this.$message.success(res.data.msg || "标签状态更新成功！");
        } else {
          this.$message.warning(res.data.msg || "标签状态更新失败！");
        }
      });
    },
    // 删除单个标签
    deleteTag(idsArr) {
      if (!idsArr || idsArr.length === 0) {
        this.$message.warning("标签id获取失败！");
        return;
      }
      api.deleteApi(`/tags`, { ids: idsArr }).then(async res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg || "标签删除成功！");
          this.currentTagGroup.tagArr = await this.getTagsOfCurrentTagGroup({
            parentId: this.currentTagGroup.id
          });
        } else {
          this.$message.warning(res.data.msg || "标签删除失败！");
        }
      });
    },
    // 批量操作标签属性请求接口
    batchOperateRequest(params) {
      api
        .putApi("/tags", { ...params, ids: this.selectedRowKeys })
        .then(async res => {
          if (res.data.code === 200) {
            this.visibleFormModal = false;
            this.$message.success(res.data.msg || "标签操作成功！");
            this.currentTagGroup.tagArr = await this.getTagsOfCurrentTagGroup({
              parentId: this.currentTagGroup.id
            });
          } else {
            if (res.data.errorList && Array.isArray(res.data.errorList)) {
              this.$message.warning(res.data.errorList[0] || "标签操作失败！");
            } else {
              this.$message.warning(res.data.msg || "标签操作失败！");
            }
          }
        });
    },
    // 批量操作标签属性
    handleBatchOperate(e) {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning("您还未勾选标签！");
        return;
      }
      switch (e.key) {
        case "updateBelongGroup":
          this.currentFormConfig = {
            title: "批量修改标签所属标签组",
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            formFieldObj: {
              parentId: {
                label: "所属标签组：",
                type: "select",
                options: this.tagGroupArr.filter(
                  item => item.id !== this.currentTagGroup.id
                ),
                placeholder: "请选择标签组"
              }
            },
            form: {
              parentId: null
            },
            formRules: {
              parentId: [
                {
                  required: true,
                  message: "请选择所属标签组",
                  trigger: "blur"
                }
              ]
            },
            handleConfirm: formDialogInstance =>
              this.commonHandleConfirm(
                formDialogInstance,
                this.batchOperateRequest
              )
          };
          this.visibleFormModal = true;
          break;
        case "batUpdateTagStatus":
          this.currentFormConfig = {
            title: "批量修改标签状态",
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            formFieldObj: {
              status: {
                label: "状态修改为：",
                type: "select",
                options: [
                  {
                    id: 0,
                    name: "上架"
                  },
                  {
                    id: -1,
                    name: "下架"
                  }
                ],
                placeholder: "请选择状态"
              }
            },
            form: {
              status: null
            },
            formRules: {
              status: [
                {
                  required: true,
                  message: "请选择标签状态",
                  trigger: "blur"
                }
              ]
            },
            handleConfirm: formDialogInstance =>
              this.commonHandleConfirm(
                formDialogInstance,
                this.batchOperateRequest
              )
          };
          this.visibleFormModal = true;
          break;
        case "batDeleteTags":
          var _this = this;
          this.$confirm({
            title: "确认删除所选标签吗?",
            content: "删除标签后，将不可恢复，请谨慎操作",
            okText: "确 定",
            cancelText: "取 消",
            onOk() {
              _this.deleteTag(_this.selectedRowKeys);
            }
          });
          break;
        default:
          break;
      }
    },
    // 表格筛选
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    // 表格筛选重置
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    }
  }
};
